import { render, staticRenderFns } from "./ManageYourAccountSection.vue?vue&type=template&id=40a35292&scoped=true&"
import script from "./ManageYourAccountSection.vue?vue&type=script&lang=js&"
export * from "./ManageYourAccountSection.vue?vue&type=script&lang=js&"
import style0 from "./ManageYourAccountSection.vue?vue&type=style&index=0&id=40a35292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a35292",
  null
  
)

export default component.exports